export default "<siteheader></siteheader>\n\n<router-outlet></router-outlet>\n\n<gototop></gototop>\n\n<sitefooter></sitefooter>\n"